import React, { Component } from 'react'
import Main from './../../components/main'
import { Table, Input, Button, Card, Spin, Tag, Pagination } from 'antd'
import PropTypes from 'prop-types'
import { API_GET_USERS } from '../../api'
import './user.css'

class User extends Component {
  constructor(props) {
    super(props)
    this.state = {
      filterDropdownVisible: false,
      dataUser: [],
      searchText: '',
      filtered: false,
      dataCount: 0,
      currentPage: 1,
    }
  }

  componentDidMount() {
    this.initialGetUsers()
  }

  onInputChange = (e) => {
    this.setState({ searchText: e.target.value })
  }

  onChangePage = (page) => {
    API_GET_USERS('', { page })
      .then((res) => {
        this.setState({ dataUser: res.data.users, dataCount: res.data.count, currentPage: page })
      })
      .catch((err) => {
        throw err
      })
  }

  onSearch = () => {
    const { searchText } = this.state
    const reg = new RegExp(searchText, 'gi')
    this.setState({
      filterDropdownVisible: false,
      filtered: !!searchText,
      dataUser: this.state.dataUser
        .map((record) => {
          const match = record.fullName.match(reg)
          if (!match) {
            return null
          }
          return {
            ...record,
            fullName: (
              <span>
                {record.fullName
                  .split(reg)
                  .map((text, i) =>
                      (i > 0
                        ? [<span className="highlight">{match[0]}</span>, text]
                        : text))}
              </span>
            ),
          }
        })
        .filter(record => !!record),
    })
  }

  initialGetUsers() {
    API_GET_USERS().then((res) => {
      this.setState({ dataUser: res.data.users, dataCount: res.data.count })
    })
      .catch((err) => {
        throw err
      })
  }

  filter = ({ field, value = [] } = {}) => {
    this.setState({
      ...this.state,
      data: this.state.dataUser.filter(x => value.includes(x[field].toLowerCase())),
    })
  }

  search = (value) => {
    API_GET_USERS('', { query: value })
      .then((res) => {
        this.setState({ dataUser: res.data.users, dataCount: res.data.count, currentPage: 1 })
      })
      .catch((err) => {
        throw err
      })
  }

  handleChangeStatus = (e, userId) => {
    this.setState({
      ...this.state,
      dataUser: this.state.dataUser.map((x) => {
        if (x.userId === userId) x.status = e
        return x
      }),
    })
  }

  handleClick = (e, userId) => {
    e.preventDefault()
    this.props.history.push(`/user-detail/${userId}`)
  }

  render() {
    const { dataUser, currentPage, dataCount } = this.state

    const columns = [
      {
        title: 'User id',
        dataIndex: 'userId',
        key: 'userId',
        render: (text, record) => (
          <div>
            <div className="block">{record.userId}</div>
          </div>
        ),
      },
      {
        title: 'Full name',
        dataIndex: 'fullName',
        key: 'fullName',
        render: (text, record) => (
          <div>
            <div className="block">{record.fullName}</div>
          </div>
        ),
      },
      {
        title: 'Phone',
        dataIndex: 'phone',
        key: 'phone',
        render: (text, record) => (
          <div>
            <div className="block">{record.phone}</div>
          </div>
        ),
      },
      {
        title: 'Email',
        dataIndex: 'email',
        key: 'email',
        render: (text, record) => (
          <div>
            <div className="block">{record.email}</div>
          </div>
        ),
      },
      {
        title: 'Active',
        dataIndex: 'active',
        key: 'active',
        render: (text, record) => (
          record.isActive !== 0 ? <Tag color="#87d068">Active</Tag> : <Tag color="#f50">#Unactive</Tag>
        ),
      },
      {
        title: 'Action',
        dataIndex: 'action',
        key: 'action',
        render: (text, record) => (
          <Button onClick={e => this.handleClick(e, record.userId)}>View</Button>
        ),
      },
    ]

    return (
      <Main>
        <div>
          <h1>Users</h1>
          <Input.Search
            className="order_search"
            enterButton
            placeholder="#Order ID, Destination Number, Amount, User ID, Customer Email or Name…"
            onSearch={this.search}
          />

          {
            dataUser ?
              <Card className="table-responsive">
                <Table
                  rowKey={record => record.userId}
                  columns={columns}
                  dataSource={dataUser}
                  pagination={false}
                />
                <div className="app-pagination">
                  <Pagination
                    current={currentPage}
                    total={dataCount}
                    onChange={this.onChangePage}
                  />
                </div>
              </Card>
            : <Card style={{ textAlign: 'center' }}><Spin /></Card>
          }

        </div>
      </Main>
    )
  }
}

User.defaultProps = {
  history: [],
}

User.propTypes = {
  history: PropTypes.object,
}

export default User




// WEBPACK FOOTER //
// src/pages/user/index.js